/** Right-side icon well (purple border, frosted). */
export const summaryStatCardIconShellClass =
  "rounded-lg border border-purple/20 bg-white/50 px-4 pt-3 pb-2 backdrop-blur-sm";

export const summaryStatCardTrailingRowClass = "flex shrink-0 items-center gap-2";

export const summaryStatCardBodyClass = "min-w-0 flex-1";
